import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { AuthorizationService } from '@services/authorization/authorization.service';

@Directive({
    selector: '[accessControl]',
    standalone: true
})
export class AccessControlDirective implements OnInit {
    private readonly templateRef = inject(TemplateRef<any>);
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly authorizationService = inject(AuthorizationService);
    @Input() accessControl?: string;

    ngOnInit() {
        if (this.isEnabled()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }

    private isEnabled(): boolean {
        if (this.authorizationService.isSysOp) {
            return true;
        }
        if (!this.accessControl) {
            return false;
        }
        return this.authorizationService.actionAllowed(this.accessControl);
    }
}
